/*=========================================================================================
  File Name: moduleUserActions.js
  Description: User Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Useror: SpeedCodeLabs
  Useror URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from "@/plugins/axios";
import { WaiterEntityModel } from "@/models/EntityModels/WaiterEntityModel";


export default {
  async CreateWaiter({}, Credentials) {
    
    return new Promise((resolve, reject) => {
      axios
        .post("/hms/waiters", new WaiterEntityModel(Credentials))

        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
 






  async EditWaiter({}, payload) {
    delete payload.contact.id
    delete payload.address.country
    delete payload.address.id


    return new Promise((resolve, reject) => {
      axios
        .patch(`/hms/waiters/${payload.id}`, new WaiterEntityModel(payload))
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },

  async GetSingleWaiter({ commit }, id) {
    
    return new Promise((resolve, reject) => {
      axios
        .get(`/hms/waiters/${id}`)
        .then((resp) => {
          // console.log("Request succeeded");
          commit("SET_BREADCRUMB", resp.data.username, {
            root: true,
          });
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
 

  GetWaiters({}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/hms/waiters", payload)
        .then((resp) => {
          console.log("Request succeeded", resp);
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  ActiveOrArchiveWaiters({}, Id) {
    
    return new Promise((resolve, reject) => {
      axios
        .get(`/hms/waiters/${Id}/soft-delete`)
        .then((resp) => {
          console.log("Request succeeded", resp);
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  

 
 



  GetUserSearch({}, payload) {
    let url = "/hms/waiter/search?";
    if (payload != null && payload != undefined) {
      if (payload.query != "" && payload.query != null) {
        url += `query=${payload.query}&`;
      }
      if (payload.status != "" && payload.status != null) {
        url += `status=${payload.status}&`;
      }
  
      if (
        payload.except != undefined &&
        payload.except != null &&
        payload.except.length > 0
      ) {
        url += `except=[${payload.except}]`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },  


};

